<template>
    <div class="container machine-index-container">
        <div class="card">
            <div class="card-header">
                <div class="row">
                    <div class="card-header-label col-2">
                        <span class="mdi mdi-book-open-page-variant custom-icon"></span>
                        <span>Máquinas</span>
                    </div>
                    <div class="card-header-search-bar col-5">
                        <b-form-input v-model="filter" id="filter-input"
                            placeholder="Escriba aquí el texto a buscar"></b-form-input>
                    </div>
                    <div class="card-header-pagination col-3">
                        <b-pagination v-model="currentPage" :total-rows="filteredList ? filteredList.length : 0"
                            :per-page="perPage" aria-controls="list-table" style="margin: 0"
                            align="center"></b-pagination>
                    </div>
                    <div class="card-header-action-buttons col-2">
                        <div>
                            <ButtonComponent :buttonText="'Refrescar'" :buttonColor="colors.BLUE_COLOR_BUTTON"
                                :buttonAction="getList" />
                        </div>
                    </div>
                </div>
            </div>
            <div v-if="isLoading" style="padding: 5ch 0">
                <SpeenComponent :isAutomatic="true" :ringWidth="14" :spinnerSize="15" :isverticalAligned="true" />
            </div>
            <div class="card-body" v-else>
                <b-table :items="filteredList" :fields="fields" small striped hover :per-page="perPage"
                    :current-page="currentPage" id="list-table">
                    <template #cell(efficiency_pct)="data">
                        <div style="display: flex; justify-content: space-around; align-items: center;">
                            <span>
                                {{ data.item.efficiency_pct }}
                            </span>
                            <span>
                                <ButtonComponent :buttonText="''" :buttonIcon="'mdi mdi-pencil'"
                                    :buttonColor="colors.GREEN_COLOR_BUTTON"
                                    :buttonAction="() => openEditModal(data.item)" 
                                    v-if="canEditMachineEfPct"
                                    />
                                <ButtonComponent :buttonText="''" :buttonIcon="'mdi mdi-history'"
                                    :buttonColor="colors.BLUE_COLOR_BUTTON"
                                    :buttonAction="() => openHistoryModal(data.item)" 
                                    />
                            </span>
                        </div>
                    </template>
                </b-table>
            </div>
        </div>
        <transition name="slide-fade">
            <MachineHistoryModal v-if="showHistoryModal" :machineId="currentItemId"
                @close-modal="closeHistoryModal" />
        </transition>
        <transition name="slide-fade">
            <MachineEditModal v-if="showEditModal" :machineId="currentItemId" @close-modal="closeEditModal"
                @refresh-list="getList" />
        </transition>
        <transition name="slide-fade">
            <ActionConfirmModal v-if="showActionConfirmModal" :contentMessage="actionConfirmModalMessage"
                :closeModal="closeActionConfirmModal" :methodForProp="methodForProp" />
        </transition>
    </div>
</template>

<script>
import axios from "axios";
import SpeenComponent from "../../common/components/SpeenComponent.vue";
import { showCustomErrorSweetAlert, showCustomSuccessSweetAlert } from "../../common/utils";
import ButtonComponent from "../../common/components/ButtonComponent.vue";
import Colors from "../../common/colors";
import ActionConfirmModal from "../../common/components/modals/ActionConfirmModal.vue";
import { filterList } from "../../common/utils";
import MachineEditModal from "../components/MachineEditModal.vue";
import MachineHistoryModal from "../components/MachineHistoryModal.vue";
import PermissionsConsts from "../../common/permissions";
import { mapGetters } from "vuex";

export default {
    name: "MachineIndexComponent",
    components: {
        SpeenComponent,
        ButtonComponent,
        ActionConfirmModal,
        MachineEditModal,
        MachineHistoryModal
    },
    data() {
        return {
            colors: Colors,
            perPage: 10,
            currentPage: 1,
            filter: '',
            listData: [],
            isLoading: true,
            showHistoryModal: false,
            showActionConfirmModal: false,
            showEditModal: false,
            currentItemExtPk: -1,
            actionConfirmModalMessage: '',
            methodForProp: null,
            fields: [
                { key: "production_line_descrip", label: "Línea de producción", sortable: true, class: "truncate" },
                { key: "station_descrip", label: "Estación", sortable: true, class: "truncate" },
                { key: "descrip", label: "Máquina", sortable: true, class: "truncate" },
                { key: "efficiency_pct", label: "% Eficiencia de máquina", sortable: true, class: "truncate" },
            ],
        };
    },
    computed: {
        ...mapGetters(['userHasPermission']),
        filteredList: function () {
            return filterList(this.listData, this.fields, this.filter);
        },
        canEditMachineEfPct(){
            return this.userHasPermission(PermissionsConsts.MACHINE_EFFICIENCY_PCT_EDIT);
        }
    },
    methods: {
        getList() {
            this.isLoading = true;
            axios.get("/api/machine/index-data")
                .then((response) => {
                    this.listData = response.data;
                })
                .catch((error) => {
                    console.error(error);
                    showCustomErrorSweetAlert(error.response.data);
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        openHistoryModal(clickedItem) {
            this.currentItemId = clickedItem.id;
            this.showHistoryModal = true;
        },
        closeHistoryModal() {
            this.currentItemId = -1;
            this.showHistoryModal = false;
        },
        openEditModal(clickedItem) {
            this.currentItemId = clickedItem.id;
            this.showEditModal = true;
        },
        closeEditModal() {
            this.currentItemId = -1;
            this.showEditModal = false;
        },
    },
    mounted() {
        this.getList();
    },
};
</script>
